/**
 * Card color swatches
 * - Click updates card image
 * - Initial state syncs active swatch with image
 * - Optional alternating initial color per card
 */

function hasSwatchImageData(button) {
  return Boolean(button && (button.getAttribute('data-image-src') || button.getAttribute('data-image-srcset')));
}

function setActiveSwatch(card, button) {
  card.querySelectorAll('.card-product-swatch-btn.is-active').forEach(function (activeButton) {
    activeButton.classList.remove('is-active');
  });
  button.classList.add('is-active');
}

function updateCardImageFromSwatch(card, button) {
  const img = card.querySelector('[data-card-image]');
  if (!img) return;

  const src = button.getAttribute('data-image-src');
  const srcset = button.getAttribute('data-image-srcset');
  const alt = button.getAttribute('data-image-alt');

  if (src) img.src = src;
  if (srcset) img.srcset = srcset;
  if (alt !== null) img.alt = alt;
}

function applySwatchSelection(card, button) {
  if (!card || !button) return;
  setActiveSwatch(card, button);
  updateCardImageFromSwatch(card, button);
}

function pickInitialSwatchButton(card, buttons) {
  if (!buttons.length) return null;

  const swatchContainer = card.querySelector('.card-product-swatches');
  const allowAlternate = Boolean(
    swatchContainer && swatchContainer.getAttribute('data-allow-initial-alternate') === 'true'
  );

  const selectedDefault = buttons.find(function (button) {
    return button.getAttribute('data-selected-default') === 'true';
  });

  let initialButton = selectedDefault || buttons[0];

  if (allowAlternate && buttons.length > 1) {
    const productId = Number.parseInt(card.getAttribute('data-product-id') || '', 10);
    if (Number.isFinite(productId)) {
      const alternateIndex = Math.abs(productId) % buttons.length;
      if (buttons[alternateIndex]) {
        initialButton = buttons[alternateIndex];
      }
    }
  }

  if (!hasSwatchImageData(initialButton)) {
    const firstWithImage = buttons.find(hasSwatchImageData);
    if (firstWithImage) {
      initialButton = firstWithImage;
    }
  }

  return initialButton;
}

function initializeCard(card) {
  if (!card || card.getAttribute('data-card-swatch-initialized') === 'true') return;

  const buttons = Array.from(card.querySelectorAll('.card-product-swatch-btn'));
  if (!buttons.length) return;

  const initialButton = pickInitialSwatchButton(card, buttons);
  if (initialButton) {
    applySwatchSelection(card, initialButton);
  }

  card.setAttribute('data-card-swatch-initialized', 'true');
}

function initializeCardSwatches(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.product-card-wrapper').forEach(function (card) {
    initializeCard(card);
  });
}

document.addEventListener('click', function (event) {
  const mediaArea = event.target.closest('.product-card-wrapper--quick-add-overlay .card__media');
  if (!mediaArea) return;

  if (
    event.target.closest('.quick-add') ||
    event.target.closest('.card-product-swatch-btn') ||
    event.target.closest('button, input, select, textarea, label')
  ) {
    return;
  }

  if (event.defaultPrevented) return;

  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  const productLink = mediaArea.querySelector('.card__media-overlay-link');
  if (!productLink || !productLink.href) return;

  event.preventDefault();
  window.location.href = productLink.href;
});

document.addEventListener('click', function (event) {
  const quickAddButton = event.target.closest('.quick-add__submit');
  if (quickAddButton) {
    event.stopPropagation();
    return;
  }

  const button = event.target.closest('.card-product-swatch-btn');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const card = button.closest('.product-card-wrapper');
  if (!card) return;

  applySwatchSelection(card, button);

  try {
    const variantId = button.getAttribute('data-variant-id');
    if (
      variantId &&
      window.ProductCardPricing &&
      typeof window.ProductCardPricing.update === 'function'
    ) {
      window.ProductCardPricing.update(card, variantId);
    }
  } catch (error) {
    console.error('Erro ao atualizar preço do card:', error);
  }

  card.setAttribute('data-card-swatch-initialized', 'true');
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initializeCardSwatches(document);
  });
} else {
  initializeCardSwatches(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initializeCardSwatches(event.target);
});

const cardSwatchObserver = new MutationObserver(function (mutations) {
  const cardsToInit = new Set();

  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (!node || node.nodeType !== 1) return;

      if (node.matches && node.matches('.product-card-wrapper')) {
        cardsToInit.add(node);
      }

      if (node.querySelectorAll) {
        node.querySelectorAll('.product-card-wrapper').forEach(function (card) {
          cardsToInit.add(card);
        });
      }
    });
  });

  cardsToInit.forEach(function (card) {
    initializeCard(card);
  });
});

if (document.documentElement) {
  cardSwatchObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const moneyFormat =
        window.theme?.moneyFormat ||
        window.Shopify?.money_format ||
        'R$ {{amount_with_comma_separator}}';

      return Shopify.formatMoney(cents, moneyFormat);
    }

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format((Number(cents) || 0) / 100);
  }

  function parseVariants(card) {
    const jsonEl = card.querySelector('[data-variants-json]');
    if (!jsonEl) return [];

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.error('Erro ao ler JSON de variantes do card', error);
      return [];
    }
  }

  function getVariantById(card, variantId) {
    const variants = parseVariants(card);
    return variants.find((variant) => String(variant.id) === String(variantId)) || null;
  }

  /*function updateComparePrice(compareEl, price, compareAtPrice, hasDiscount) {
    if (!compareEl) return;

    const basePrice = hasDiscount ? compareAtPrice : price;
    compareEl.textContent = formatMoney(basePrice);
    compareEl.classList.remove('hidden');
  }*/

  function updatePixPrice(pixEl, price) {
    if (!pixEl) return;

    const pixPrice = Math.round(price * 0.95);
    pixEl.textContent = formatMoney(pixPrice);
  }

  function updateInstallments(installmentsEl, price) {
    if (!installmentsEl) return;

    let divisor = 3;
    if (currentPrice < 10000) {divisor = 1;}
    else if (currentPrice < 15000) {divisor = 2;}
    else if (currentPrice < 20000) {divisor = 3;}
    else if (currentPrice < 25000) {divisor = 3;}
    else if (currentPrice < 30000) {divisor = 3;}

    const installmentValue = Math.round(price / divisor);
    installmentsEl.textContent = `ou `+ divisor + `x de ${formatMoney(installmentValue)}`;
  }

  function updateDiscountBadge(card, price, compareAtPrice, available) {
    const badgeEl = card.querySelector('[data-discount-badge]');
    if (!badgeEl) return;

    const hasDiscount = available && compareAtPrice > price;

    if (!hasDiscount) {
      badgeEl.textContent = '';
      badgeEl.classList.add('hidden');
      return;
    }

    const discountPercent = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
    badgeEl.textContent = `${discountPercent}% OFF`;
    badgeEl.classList.remove('hidden');
  }

  function updateProductLink(card, variant) {
    const linkEls = card.querySelectorAll('[data-product-link]');
    if (!linkEls.length || !variant?.url) return;

    linkEls.forEach((linkEl) => {
      linkEl.setAttribute('href', variant.url);
    });
  }

  function updateProductImage(card, variant) {
    const imageEl = card.querySelector('[data-card-image]');
    if (!imageEl || !variant?.featured_image) return;

    imageEl.setAttribute('src', variant.featured_image);
  }

  function updateProductCard(card, variantId) {
    if (!card || !variantId) return;

    const variant = getVariantById(card, variantId);
    if (!variant) return;

    const price = Number(variant.price || 0);
    const compareAtPrice = Number(variant.compare_at_price || 0);
    const available = Boolean(variant.available);
    const hasDiscount = compareAtPrice > price;

    const compareEl = card.querySelector('[data-price-compare]');
    const pixEl = card.querySelector('[data-price-pix]');
    const installmentsEl = card.querySelector('[data-price-installments]');

    //updateComparePrice(compareEl, price, compareAtPrice, hasDiscount);
    updatePixPrice(pixEl, price);
    updateInstallments(installmentsEl, price);
    updateDiscountBadge(card, price, compareAtPrice, available);
    updateProductLink(card, variant);
    updateProductImage(card, variant);

    card.setAttribute('data-initial-variant-id', variant.id);
  }

  window.ProductCardPricing = {
    update: updateProductCard
  };

  document.addEventListener('variant:changed', function (event) {
    const card = event.target.closest('[data-product-card]');
    const variantId = event.detail?.variantId;

    if (!card || !variantId) return;
    updateProductCard(card, variantId);
  });
})();